module.exports = __webpack_public_path__ + "static/media/29BDOS24.b12fc123.jpg";